export default {
  setConfig: (state, payload) => {
    state.config = payload;
  },

  setUserProfile: (state, payload) => {
    state.profile = payload;
  },

  setToken: (state, payload) => {
    state.token = payload;
  },

  setPortalInfo: (state, payload) => {
    state.portalInfo = payload;
  },

  clear: (state) => {
    sessionStorage.clear();
    localStorage.removeItem(state.config.VUE_APP_TOKEN_KEY);
    state.portalInfo = null;
    state.profile = null;
    state.token = null;
    state.acceptTerms = null;
  },

  setAcceptTerms: (state, payload) => {
    state.acceptTerms = payload;
  },

  setConfirmAcceptTerms: (state, payload) => {
    state.acceptTerms.isAcceptTerms = payload;
  }
  
};
